import { getPlatform } from "@web/src/app/utils/platform";
const isWindows = getPlatform() === "windows";
console.log(getPlatform());
export const Shortcuts = {
  esc: "esc",
  view: {
    default: "D",
    week: "W",
    calendar: "C",
    zen: "Z",
    hashtag: "A",
  },
  editMode: {},
  selectMode: {
    arrows: "left+up+right+down", // for tutorial only
    edit: "enter", // for tutorial only
    history: "H",
    moveModifier: isWindows ? "mod" : "alt",
    moveTodoDown: isWindows ? "mod+down" : "alt+down",
    moveTodoLeft: isWindows ? "mod+left" : "alt+left",
    moveTodoRight: isWindows ? "mod+right" : "alt+right",
    moveTodoUp: isWindows ? "mod+up" : "alt+up",
    navigateDown: "down",
    navigateLeft: "left",
    navigateRight: "right",
    navigateUp: "up",
    notes: "N",
    refreshTodos: "r",
    refreshCalendars: "alt+r",
    startEditWithCommand: "/",
    toggleTimer: "t",
    spaceNavigateTrigger: "s",
    openLink: "l",
    focusMode: "f",
    toggleTodoMenu: "`",
    timerDefault1: "1",
    timerDefault2: "2",
    timerDefault3: "3",
    timerDefault4: "4",
  },
  anyMode: {
    indent: "tab",
    unindent: "shift + tab",
    complete: "mod + enter",
    completeNoMove: "mod + shift + enter",
    search: "mod + f",
    collapse: "alt + c",
    rolloverYstd: "alt + r",
    globalCommandPalette: "mod + k",
    undo: "mod + z",
    redo: "mod + shift + z",
    newTodoWithHashtags: "alt + enter",
  },
};
